
import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '@ngx-ivengi/authentication';
import {UIRouter} from '@uirouter/angular';
import {AuthDevice} from './auth-device.model';
import {ProfileService} from './profile.service';
import {Profile} from './profile.model';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html'
})
export class ProfileFormComponent implements OnInit {

  public profile: Profile = new Profile();
  public activeAuthDeviceId = localStorage.getItem(this.authService.config.getAuthDeviceTokenStorageKey());
  public authDevices: AuthDevice[];

  constructor(
    protected router: UIRouter,
    protected profileService: ProfileService,
    protected authService: AuthenticationService
  ) {}

  public ngOnInit(): void {
    this.profileService.get().subscribe((profile: Profile) => {
      this.profile = profile;
    });

    this.profileService.authDevices().subscribe((authDevices: AuthDevice[]) => {
      this.authDevices = authDevices;
    });
  }

  public save() {
    this.profileService.update(this.profile).subscribe((result: boolean) => {
      this.router.stateService.go('profile', null, {reload: true});
    });
  }

  public logoutDevice(device) {
    this.profileService.logoutDevice(device.id).subscribe(() => {
      this.authDevices.splice(this.authDevices.indexOf(device), 1);
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/profile/profile-form.component.ts